var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 40,
    rx: 3,
    fill: "#392D69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 19.25V14H23.25V19.25H18V20.75H23.25V26H24.75V20.75H30V19.25H24.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBtn);
export default __webpack_public_path__ + "static/media/plusBtn.deac35055f0559b6fec3753a8b11f571.svg";
export { ForwardRef as ReactComponent };